module.exports = __webpack_public_path__ + "static/media/15_avatar.bb0b8edd.png";